import {
    CLEAR_NOTIFICATIONS_BADGE,
    LOAD_MORE_NOTIFICATIONS_FAILURE,
    LOAD_MORE_NOTIFICATIONS_START,
    LOAD_MORE_NOTIFICATIONS_SUCCESS,
    MARK_NOTIFICATIONS_READ_SUCCESS,
    SET_NOTIFICATIONS,
    SET_NOTIFICATIONS_ERROR,
    SET_NOTIFICATIONS_LAST_READ_AT
} from 'store/actions/types';

const initialState = {
    items: [],
    badge: '0',
    unreadCount: 0,
    lastReadAt: null,
    error: null,
    isLoadingMore: false,
    hasMore: true
};

export default function notificationsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_NOTIFICATIONS:
            return {
                ...state,
                items: action.payload.items,
                badge: action.payload.badge,
                unreadCount: action.payload.unreadCount,
                hasMore: action.payload.hasMore,
                error: null
            };

        case LOAD_MORE_NOTIFICATIONS_START:
            return {
                ...state,
                isLoadingMore: true,
                error: null
            };

        case LOAD_MORE_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                items: [
                    ...state.items,
                    ...action.payload.items.filter(
                        item => !state.items.some(existing => existing.id === item.id)
                    )
                ],
                isLoadingMore: false,
                hasMore: action.payload.hasMore
            };

        case LOAD_MORE_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                isLoadingMore: false,
                error: action.payload
            };

        case SET_NOTIFICATIONS_ERROR:
            return {
                ...state,
                error: action.payload
            };

        case SET_NOTIFICATIONS_LAST_READ_AT:
            return {
                ...state,
                lastReadAt: action.payload
            };

        case CLEAR_NOTIFICATIONS_BADGE:
            return {
                ...state,
                badge: '0',
                unreadCount: 0
            };
        case MARK_NOTIFICATIONS_READ_SUCCESS:
            return {
                ...state,
                badge: '0',
                unreadCount: 0,
                items: state.items.map(item => ({
                    ...item,
                    unread: false
                }))
            };
        default:
            return state;
    }
}
